import styled from "styled-components"
import { TextInput, TextSpan } from "../../common/Text"
import { StyledButton } from "../../common/Buttons"
import { useState } from "react"
import { toast } from "react-toastify"
import { useFormContext } from "react-hook-form"
import useTimer from "../../../hooks/useTimer"
import useVerifyMobile from "../../../hooks/SignupPage/useVerifyMobile"
import { useRecoilValue, useResetRecoilState } from "recoil"
import sessionIdState from "../../../recoil/SignupPage/sessionId/atom"

const VerificationCodeInput = () => {
  const { setValue, watch } = useFormContext()
  const isPhoneNumberVerified = watch("isPhoneNumberVerified")
  const { timeLeft, minutes, seconds } = useTimer()

  const sessionId = useRecoilValue(sessionIdState)
  const resetSessionId = useResetRecoilState(sessionIdState)
  const [verificationCode, setVerificationCode] = useState("")
  const { refetch: verifyMobile } = useVerifyMobile({
    sessionId,
    verificationCode,
  })

  const requestVerification = () => {
    if (timeLeft <= 0) {
      toast.error(
        "제한 시간이 초과되었습니다. 인증 번호를 다시 요청해주세요.",
        { position: "top-right" }
      )
    } else if (verificationCode) {
      verifyMobile()
        .then(() => {
          setValue("isPhoneNumberVerified", true)
          resetSessionId()
          toast("인증되었습니다.", {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "light",
          })
        })
        .catch((err) => {
          console.log(err)
        })
    } else {
      toast.error("인증 번호를 제대로 입력해주세요.", {
        position: "top-right",
        autoClose: 2000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        progress: undefined,
        theme: "light",
      })
    }
  }
  return (
    <VerificationCodeInputBox>
      <TextInput
        $isError={false}
        placeholder="인증 번호 입력"
        style={{
          borderTopRightRadius: 0,
          borderBottomRightRadius: 0,
        }}
        onChange={(e) => setVerificationCode(e.target.value)}
        onKeyUp={(e) => {
          if (e.key === "Enter") {
            requestVerification()
          }
        }}
        disabled={isPhoneNumberVerified}
      />
      {!isPhoneNumberVerified && (
        <TimerDiv>
          <TextSpan
            fontSize={12}
            color={
              timeLeft > 0
                ? "var(--custom-light-brown)"
                : "var(--custom-light-red)"
            }
          >{`${minutes} : ${seconds}`}</TextSpan>
        </TimerDiv>
      )}
      <StyledButton
        $size="large"
        style={{
          borderTopLeftRadius: 0,
          borderBottomLeftRadius: 0,
          fontSize: 15,
          pointerEvents: isPhoneNumberVerified ? "none" : "inherit",
        }}
        onClick={requestVerification}
        disabled={isPhoneNumberVerified}
        $bgColor={isPhoneNumberVerified ? "var(--custom-platinum)" : ""}
      >
        인증 완료
      </StyledButton>
    </VerificationCodeInputBox>
  )
}

export default VerificationCodeInput

const VerificationCodeInputBox = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  height: 50px;
  border-radius: 20px;

  > * {
    &:first-child {
      flex-grow: 1;
    }

    &:last-child {
      flex-basis: 110px;
      flex-shrink: 0;
    }
  }
`

const TimerDiv = styled.div`
  position: absolute;
  right: 120px;
  font-size: 13px;
`
